import React, { Component, Fragment } from 'react'
import CardSimple from '../../../Utils/Cards/cardSimple';
import ToolbarSimple from '../../../Utils/Toolbar/ToolbarSimple';
import CardDS from '../../../Utils/Cards/casdsDS';


//manejo de tabs
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';

import LoadMask from "Utils/LoadMask/LoadMask";

import { BODEGAS_TRANSICION_ID } from '../../../../../utility/constants';

import HistoricoGrid from './HistoricoGrid';
import InventarioGrid from './Inventario_grid';
import MovimientosGrid from './MovimientosGrid';
import ToolbarMovimientos from './FiltrosMovimientos';
import BodegaMateriaPrimaGrid from './BodegasTransicion/BodegaMateriaPrimaGrid';
import BodegaProduccionGrid from './BodegasTransicion/BodegaProduccionGrid';
import KardexTransicionGrid from './BodegasTransicion/KardexTransicionGrid';
import { toInteger } from 'lodash';


export default class EstadoBodegaGrid extends Component {
    componentWillMount() {
        const { leer, page, listDS } = this.props;
        leer(this.props.match.params.id);
        this.props.getDespachosPendientes(this.props.match.params.id);
        // lectura de los despachos

    }
    searchInventario = (search) => {
        const bandera = "INVENTARIO"
        this.props.searchChange(search, this.props.match.params.id, bandera);
    }

    searchHistorial = (search) => {
        const bandera = "HISTORIAL"
        this.props.searchChange(search, this.props.match.params.id, bandera);
    }

    searchHistorialMovimientos = (search) => {
        const bandera = "MOVIMIENTOS"
        this.props.searchChange(search, this.props.match.params.id, bandera);
    }

    render() {
        const { data, loader, listar: onPageChange, onSortChange, eliminar, item, changeTipo, changeUsuario, permisos } = this.props;
        const mostrarBodegasVirtuales = BODEGAS_TRANSICION_ID.includes(toInteger(this.props.match.params.id));

        return (
            <CardSimple
                titulo={`Bodega: ${item.nombre}`}
            >
                {
                    (this.props.despachos_pendientes && this.props.despachos_pendientes.length > 0) && (
                        <div>
                            <CardDS
                                data={this.props.despachos_pendientes}
                                loader={loader}
                                titulo="MOVIMIENTOS BODEGA PENDIENTES"
                                id_bodega={this.props.match.params.id}
                                permisos={permisos}
                                link={`/estado_bodega/despacho/${this.props.match.params.id}`}
                            />
                            <br />
                        </div>
                    )
                }
                <br />
                <div className="row">
                    <div className="mb-4 col-12 m-0 p-0">
                        <div className="mb-4 ">
                            <div className=""><h6 className="m-0"></h6></div>
                            <div className="p-0 px-3 pt-3 p-b">


                                {/* TABS PARA BODEGAS NORMALES */}
                                {!mostrarBodegasVirtuales && (
                                <Tabs
                                    defaultActiveKey="INVENTARIO"
                                    tabBarPoition="top"
                                    onchange={this.callback}
                                    renderTabBar={() => <ScrollableInkTabBar />}
                                    renderTabContent={() => <TabContent />}
                                >
                                    <TabPane tab="INVENTARIO" key="INVENTARIO">
                                        <ToolbarSimple
                                            textBoton={this.props.permisos.crear_editar_bodegas ? "Despachar" : undefined}
                                            margen={"0"}
                                            ruta={`/estado_bodega/crear/${this.props.match.params.id}`}
                                            buscar={this.searchInventario}
                                            buscador={this.props.search}
                                            placeholder={"Buscar por: Nombre, Código"}
                                            permisos={true}
                                            downloadButton={{
                                                label: 'DESCARGAR',
                                                handleDownload: this.props.permisos.crear_editar_bodegas ? this.props.descargaArchivoInventarioBodegaEP : undefined
                                            }}
                                        />
                                        <br />
                                        <LoadMask loading={loader} light type={"TailSpin"}>
                                            <InventarioGrid
                                                {...this.props}
                                                id_bodega={this.props.match.params.id}
                                            />
                                        </LoadMask>
                                    </TabPane>
                                    <TabPane tab="HISTORIAL " key="HISTORIAL">
                                        <ToolbarSimple
                                            textBoton={this.props.permisos.crear_editar_bodegas ? "Despachar" : undefined}
                                            margen={"0"}
                                            ruta={`/estado_bodega/crear/${this.props.match.params.id}`}
                                            buscar={this.searchHistorial}
                                            buscador={this.props.search}
                                            placeholder={"Buscar por: No. Despacho, Nombre"}
                                            permisos={true}
                                        />
                                        <br />
                                        <LoadMask loading={loader} light type={"TailSpin"}>
                                            <HistoricoGrid
                                                id_bodega={this.props.match.params.id}
                                                {...this.props} />
                                        </LoadMask>
                                    </TabPane>
                                    <TabPane tab="KARDEX " key="KARDEX">    
                                        <br /> 
                                        <ToolbarMovimientos 
                                           changeUsuario={changeUsuario}
                                           usuarios={this.props.usuarios}
                                           changeTipo={changeTipo}
                                           tipos={this.props.tipos}
                                           id_bodega={this.props.match.params.id}
                                           dateStart = {this.props.dateStart}
                                           setDateStart = {this.props.setDateStart}
                                           dateEnd= {this.props.dateEnd}
                                           setDateEnd = {this.props.setDateEnd}
                                        />           
                                        <br />                                                         
                                        <ToolbarSimple
                                            textBoton={this.props.permisos.crear_editar_bodegas ? "Despachar" : undefined}
                                            margen={"0"}
                                            ruta={`/estado_bodega/crear/${this.props.match.params.id}`}
                                            buscar={this.searchHistorialMovimientos}
                                            buscador={this.props.search}
                                            placeholder={"Buscar por: Nombre"}
                                            permisos={true}
                                            
                                        />  
                                        <br />
                                        <LoadMask loading={loader} light type={"TailSpin"}>
                                            <MovimientosGrid
                                                id_bodega={this.props.match.params.id}
                                                {...this.props} />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br/>
                                            <br/>
                                        </LoadMask>
                                    </TabPane>
                                </Tabs>
                                )}


                                {/* TABS PARA BODEGAS DE TRANSICION */}
                                {mostrarBodegasVirtuales && (
                                    <Tabs
                                        defaultActiveKey="INVENTARIO TRANSICION"
                                        tabBarPoition="top"
                                        onchange={this.callback}
                                        renderTabBar={() => <ScrollableInkTabBar />}
                                        renderTabContent={() => <TabContent/> }
                                        >
                                        <TabPane tab="BODEGA MP" key="BODEGA MP">
                                            <BodegaMateriaPrimaGrid
                                                key="materia-prima"
                                                {...this.props}
                                                idBodega={this.props.match.params.id}/>
                                        </TabPane>
                                        <TabPane tab="BODEGA PRODUCCIÓN" key="BODEGA PRODUCCION">
                                            <BodegaProduccionGrid
                                                key="materia-mp"
                                                {...this.props}
                                                idBodega={this.props.match.params.id}/>
                                        </TabPane>
                                        <TabPane tab="KARDEX" key="KARDEX TRANSICION">
                                            <KardexTransicionGrid
                                                key="kardex-transicion"
                                                mostrarBodegasVirtuales={mostrarBodegasVirtuales}
                                                {...this.props}
                                                idBodega={this.props.match.params.id}/>
                                        </TabPane>
                                    </Tabs>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </CardSimple>
        );
    }
}
